import allCombos from '@/helpers/allCombos.json'

const eq_chart_mix = {
  // props: {
  // hero: Object,
  // opponent: Object,
  // handInfo: Object,
  // skeleton: Boolean,
  // handsHero: Array,
  // handsOpponent: Array,
  // handsActiveHero: Array,
  // handsActiveOpponent: Array,
  // handsPinnedHero:Array,
  // handsPinnedOpponent:Array,
  // styleLegend: String,
  // styleAxes: { default: () => '--axis-space: 1rem;' },
  // styleSvg: String,
  // simpleView
  // },
  data() {
    return {
      showTooltip: false,
      // axisTicks: [0, 50, 100],
    }
  },
  methods: {
    getPlayerPoints(player, ppPos, rangeKey) {
      // console.log('getPlayerPoints', player, ppPos, rangeKey)
      if (this.simpleView) {
        // console.log('getPointsFromPlayer')
        return this.getPointsFromPlayer(player, ppPos, rangeKey)
      }
      // console.log('getPointsFromHands')
      return this.getPointsFromHands(player, ppPos, rangeKey)
    },
    getPointsFromPlayer(player, ppPos) {
      // TODO rm after 3way rls
      const dataPlayer = ['hero', '0'].includes(player) ? this.hero : this.opponent
      const eqs = dataPlayer.hand_eqs || []
      const percentiles = dataPlayer.eq_percentile || []

      let res = []
      res = eqs.map((i, idx) => ({
        x_percentil: percentiles[idx],
        y_eq: i,
        hand: allCombos[idx],
      }))
      res = res.filter(i => i.x_percentil >= 0)
      res = res.sort((a, b) => (a.x_percentil < b.x_percentil ? -1 : 1))

      res = res.map((i, idx) => {
        const x = i.x_percentil
        const y = 1 - i.y_eq
        return {
          hand: i.hand,
          x,
          y,
          eq: i.y_eq,
          ppPos,
          player,
          circle_size: 1,
        }
      })

      // BE can return the last value not 1
      if (res.length) {
        res[res.length - 1].x = 1
      }
      return res
    },
    getPointsFromHands(player, ppPos, rangeKey) {
      const playerHands = (this.hands || []).filter(i => i.players[player].eq_percentile >= 0)
      let res = []
      res = playerHands.map((i, idx) => ({
        hand: i.id,
        x: i.players[player].eq_percentile,
        y: 1 - i.players[player].eq,
        eq: i.players[player].eq,
        ppPos,
        player,
        circle_size: i.players[player][rangeKey],
        rangeKey,
        orig_hand: i,
      }))
      res = res.sort((a, b) => {
        if (a.y === b.y) return a.x - b.x // if y is the same, sort by x othervise you get broken svg path in firefox - why to be continoued from @luXmelo
        return a.x < b.x ? -1 : 1
      })
      // BE can return the last value not 1
      if (res.length) {
        res[res.length - 1].x = 1
      }
      return res
    },
    getFilteredPoints(points, hands) {
      if (!hands?.length) return []
      return points.filter(i => hands.some(id => id === i.hand))
    },
  },
  computed: {
    heroIP() {
      return this.hero.relative_postflop_position === 'IP'
    },
    ipPlayer() {
      return this.hero.relative_postflop_position === 'IP' ? this.hero : this.opponent
    },
    oopPlayer() {
      return this.hero.relative_postflop_position === 'OOP' ? this.hero : this.opponent
    },
    ipPointsXY() {
      const player = this.ipPlayer.is_hero ? '0' : '1'
      const res = this.getPlayerPoints(player, player.relative_postflop_position, this.rangeKey)
      return res
    },
    oopPointsXY() {
      const player = this.oopPlayer.is_hero ? '0' : '1'
      const res = this.getPlayerPoints(player, player.relative_postflop_position, this.rangeKey)
      return res
    },
    handsIPPointsXY() {
      const hands = this.heroIP ? this.handsHero : this.handsOpponent
      return this.getFilteredPoints(this.ipPointsXY, hands)
    },
    handsOOPPointsXY() {
      const hands = !this.heroIP ? this.handsHero : this.handsOpponent
      return this.getFilteredPoints(this.oopPointsXY, hands)
    },
    pointsIPActiveXY() {
      let hands = []
      if (this.showTooltip) {
        hands = this.heroIP ? this.handsActiveHero : this.handsActiveOpponent
      } else if (this.player === '0' && this.heroIP) {
        hands = this.handsActiveHero
      } else if (this.player === '1' && !this.heroIP) {
        hands = this.handsActiveOpponent
      }
      return this.getFilteredPoints(this.ipPointsXY, hands)
    },
    pointsOOPActiveXY() {
      let hands = []
      if (this.showTooltip) {
        hands = !this.heroIP ? this.handsActiveHero : this.handsActiveOpponent
      } else if (this.player === '0' && !this.heroIP) {
        hands = this.handsActiveHero
      } else if (this.player === '1' && this.heroIP) {
        hands = this.handsActiveOpponent
      }
      return this.getFilteredPoints(this.oopPointsXY, hands)
    },
    pointsIPPinnedXY() {
      const hands = this.heroIP ? this.handsPinnedHero : this.handsPinnedOpponent
      // console.log('pointsIPPinnedXY', hands, this.getFilteredPoints(this.ipPointsXY, hands))
      return this.getFilteredPoints(this.ipPointsXY, hands)
    },
    pointsOOPPinnedXY() {
      const hands = !this.heroIP ? this.handsPinnedHero : this.handsPinnedOpponent
      // console.log('pointsOOPPinnedXY', this.getFilteredPoints(this.oopPointsXY, hands))
      return this.getFilteredPoints(this.oopPointsXY, hands)
    },
    pointsActiveXY() {
      return [...this.pointsOOPActiveXY, ...this.pointsIPActiveXY]
    },
    pointsPinnedXY() {
      return [...this.pointsOOPPinnedXY, ...this.pointsIPPinnedXY]
    },
  },
}
export default eq_chart_mix
